import React, { Suspense } from 'react';
import ChangeMyInfo from '../components/me/info/ChangeMyInfo';
import ChangePassword from '../components/me/password/ChangePassword';
import Container from '../components/shared/container/Container';
import ContainerHeader from '../components/shared/container/ContainerHeader';
import ContainerTitle from '../components/shared/container/ContainerTitle';
import CommonLoader from '../components/shared/loaders/CommonLoader';
import PageContainer from '../components/shared/page/PageContainer';
import PageTitle from '../components/shared/page/PageTitle';
import PageTitleContainer from '../components/shared/page/PageTitleContainer';

const Profile = () => {
  return (
    <Suspense fallback={<CommonLoader />}>
      <section>
        <PageTitleContainer>
          <PageTitle title={'Профіль'} />
        </PageTitleContainer>
        <PageContainer>
          <div className="grid grid-cols-2 gap-3 lg:gap-4">
            <Container className="col-span-2 lg:col-span-1">
              <ContainerHeader>
                <ContainerTitle title={'Змінити інформацію'} />
              </ContainerHeader>
              <ChangeMyInfo />
            </Container>
            <Container className="col-span-2 lg:col-span-1">
              <ContainerHeader>
                <ContainerTitle title={'Змінити пароль'} />
              </ContainerHeader>
              <ChangePassword />
            </Container>
          </div>
        </PageContainer>
      </section>
    </Suspense>
  );
};

export default Profile;
